import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthState, User } from "../../types/user";

const demoUsers: User[] = [
  {
    id: "1",
    email: "admin@example.com",
    name: "Admin User",
    role: "admin",
    phone: "+1 (555) 123-4567",
    address: "123 Main St, City, State 12345",
    createdAt: "2024-01-01",
    status: "active",
  },
  {
    id: "2",
    email: "stylist@example.com",
    name: "Sarah Smith",
    role: "stylist",
    phone: "+1 (555) 234-5678",
    address: "456 Elm St, City, State 12345",
    createdAt: "2024-01-02",
    status: "active",
  },
  {
    id: "3",
    email: "receptionist@example.com",
    name: "John Doe",
    role: "receptionist",
    phone: "+1 (555) 345-6789",
    address: "789 Oak St, City, State 12345",
    createdAt: "2024-01-03",
    status: "active",
  },
];

const initialState: AuthState = {
  user: null,
  token: null,
  isAuthenticated: false,
  loading: false,
  error: null,
  expiry: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (
      state,
      action: PayloadAction<{ user: User; token: string; expiry: number }>
    ) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.error = null;
      state.expiry = action.payload.expiry;
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;
    },
    updateUser: (state, action: PayloadAction<Partial<User>>) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
      }
    },
    rehydrateAuth: (
      state,
      action: PayloadAction<{ user: User; token: string; expiry: number }>
    ) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.expiry = action.payload.expiry;
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
  updateUser,
  rehydrateAuth,
} = authSlice.actions;
export default authSlice.reducer;
export const demoUsersList = demoUsers;
